import { Button, Collapse, Grid, List, ListItem, Typography } from '@mui/material';
import useTranslation from 'hooks/useTranslation/useTranslation';
import React, { useState } from 'react';
import QRCode from 'v2/components/QRCode/QRCode';
import MobileAppRowHeader from './MobileAppRowHeader';

interface Props {
  idPrefix: string;
  mobileDeviceId: string;
  label: string;
  isResendButtonVisible: boolean;
  onResendInvitation: (deviceId: string) => void;
  sendInvitationLoading: boolean;
  resendDisabled: boolean;
  qrCodeValue?: string;
}

const MobileAppRowDisconnected: React.FC<Props> = ({
  idPrefix,
  mobileDeviceId,
  label,
  isResendButtonVisible,
  onResendInvitation,
  sendInvitationLoading,
  resendDisabled,
  qrCodeValue
}) => {
  const { translation } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  const isExpandable = isResendButtonVisible || !!qrCodeValue;

  return (
    <Grid container direction="column" spacing={0.5}>
      <MobileAppRowHeader
        id={`${idPrefix}-row`}
        label={label}
        statusLabel={translation.disconnected}
        statusColor="error"
        isExpandable={isExpandable}
        isOpen={isOpen}
        onToggle={() => setIsOpen((previous) => !previous)}
      />
      <Collapse in={isOpen} timeout="auto" unmountOnExit>
        <Grid container direction="row" wrap="nowrap" justifyContent="center" alignItems="center" width="100%">
          <List component="div" disablePadding>
            <ListItem>
              <Grid container direction="column">
                {qrCodeValue && (
                  <>
                    <Typography variant="body2">{translation.atlas_access_disconnected_description}</Typography>
                    <QRCode id={`${idPrefix}-qr-code`} value={qrCodeValue} sx={{ alignSelf: 'center' }} />
                  </>
                )}
                {isResendButtonVisible && (
                  <Button
                    id={`${idPrefix}-resend-button`}
                    loading={sendInvitationLoading}
                    disabled={resendDisabled}
                    onClick={() => onResendInvitation(mobileDeviceId)}
                    variant="outlined"
                    sx={{ alignSelf: 'center' }}
                  >
                    {translation.resend_invite}
                  </Button>
                )}
              </Grid>
            </ListItem>
          </List>
        </Grid>
      </Collapse>
    </Grid>
  );
};

export default MobileAppRowDisconnected;
